import AlertTriangleFilledIcon from '@elementor/icons/AlertTriangleFilledIcon';
import ChevronDownSmallIcon from '@elementor/icons/ChevronDownSmallIcon';
import Box from '@elementor/ui/Box';
import Typography from '@elementor/ui/Typography';
import { useScannerWizardContext } from '@context/scanner-wizard-context';
import {
	StyledAccordion,
	StyledAccordionSummary,
} from '@styles/manual-fixes.styles';
import { __ } from '@utils/i18n';
import AltTextForm from './components/alt-text-form';
import ImagePreview from './components/image-preview';

const AltTextLayout = () => {
	const { openIndex, handleOpen, openedBlock, sortedViolations } =
		useScannerWizardContext();

	return (
		<Box sx={{ pb: 8 }}>
			{sortedViolations[openedBlock].map((item, index) => (
				<StyledAccordion
					key={`${item.ruleId}-${index}`}
					elevation={0}
					square
					disableGutters
					expanded={openIndex === index}
					onChange={handleOpen(index, item)}
				>
					<StyledAccordionSummary
						expandIcon={<ChevronDownSmallIcon />}
						aria-controls={`manual-panel-${index}`}
						id={`manual-panel-${index}`}
					>
						<AlertTriangleFilledIcon color="error" fontSize="small" />

						<ImagePreview element={item.node} isThumbnail />

						<Typography variant="body2" as="h4" noWrap>
							{__('Image')}
						</Typography>
					</StyledAccordionSummary>

					<AltTextForm item={item} />
				</StyledAccordion>
			))}
		</Box>
	);
};

export default AltTextLayout;
